/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
// import 'bootstrap/js/src/toast';
// import 'bootstrap/js/src/tooltip';
// import 'bootstrap/js/src/carousel';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
/*import lazysizes from 'lazysizes'*/
import LazyLoader from './components/lazyloader';


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").text(fileName);
  })


  function slick_thumbs()
  {
    var images_count = $('.product-thumbs img').length;
    var count;
    if( $('.product-thumbs img').length > 2 ) { count = 3; } else { count = 2; } 
    setTimeout(function(){
      $('.products-imagescover').slick(
        {
        "asNavFor":".product-thumbs",
         "rows": 0,
         "slidesToShow": 1,
         "lazyload": "ondemand",
         "arrows":false
        });

        $('.product-thumbs').slick(
        {"asNavFor":".products-imagescover",
        "slidesToShow": count , 
        "slidesToScroll": 1,
        "lazyload": "ondemand", 
        "focusOnSelect": true,
        "centerMode":false,
        "rows": 0,
        "prevArrow":'<button type="button" class="btn btn-link slick-prev slick-arrow" style="display: flex;"><i class="material-icons left"></i></button>',
        "nextArrow":'<button type="button" class="btn btn-link slick-next slick-arrow" style="display: flex;"><i class="material-icons right"></i></button>',
        "variableWidth": true
      }
      );

      } , 3000);
    }
    
   slick_thumbs();

    $(document).ajaxComplete(( event, xhr, settings ) => {
    try {
      // if there is new content which contains lazyload images
      if (xhr.responseText.indexOf("data-src") !== -1) {
        LazyLoader.updateImagesLazyLoad()
                  .loadAllImagesLazyLoad();
      }

      slick_thumbs();
    }
    catch(err) {
      console.log(err.message);
    }
  });

  $('.search-icon').click(function(){
    $('.search-widget').toggle();
  });

  $('.question-button').click(function(e){
        e.preventDefault;
        window.location.href = document.location.origin+'/faqs/';
  });
  
      
      if ($(window).width() > 992 ) {

     /* var heightBlock = ($(window).innerHeight() - $('#header').outerHeight());

      $('.custom-home-block').css('height', heightBlock);*/
  
     
    var slideHeight = ($(window).innerHeight() - $('#header').outerHeight()) / 4;
      
      $('.custom-carousel .custom-item-carousel').css('height', slideHeight);

      $('.menu-sub').css('top' , $('.header-top').innerHeight() );

      $('.wrapperTop::after').css('top' , $('.header-top').innerHeight() );

     }
      
      if ($(window).width() >= 540 ) {
      $('.custom-carousel').slick({
      infinite: true,
      autoplay: true,
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      vertical:true,
      swipeToSlide:true,
      swipe:true,
      verticalSwiping:true,
      prevArrow:'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_up</i></button>',
      nextArrow:'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_down</i></button>',
      responsive: [
              {
                "breakpoint": 1200,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 992,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 768,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 576,
                "settings": {
                  "slidesToShow": 1
                }
              }
            ]
      });
    }
    else
    {
      $('.custom-carousel').slick({
      infinite: true,
      autoplay: true,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;top:45%; left:-55%;"><i class="material-icons text-primary" style="font-size:3rem;">keyboard_arrow_left</i></button>',
      nextArrow:'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;top:45%; left:55%;"><i class="material-icons text-primary" style="font-size:3rem;">keyboard_arrow_right</i></button>',
      });
    }


/* header fixed */
  if (!$('body').hasClass("cart-empty")) {
   $(window).scroll(function() { 
          var height = $(".l-header").height();  
          var scroll = $(window).scrollTop();
          if (scroll >= height) {
              $(".l-header").addClass("header-fixed");
          } else {
              $(".l-header").removeClass("header-fixed");
          }
      });
 }
/* / header fixed*/
    if ($('#less-desc').text().indexOf("...") != -1 )
    {
        $('.more-button').show();
    }

  $('.devis-icon').click(function(){
       jQuery.getScript("https://www.google.com/recaptcha/api.js?hl=fr");
  });

  $('#product .devis-product-button').click(function(){
       jQuery.getScript("https://www.google.com/recaptcha/api.js?hl=fr");
  })

    $('.projet-button').click(function(){
       jQuery.getScript("https://www.google.com/recaptcha/api.js?hl=fr");
  })

      if ($(window).width() <= 414 ) {
        setTimeout(function() {
        $('#acb-banner').css('display' , 'flex');
        }, 5000);
     }

});

document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
});
